import { styled } from 'linaria/react';
import { Form } from 'formik';
import { theme } from '../../../components/Theme';
import { toRem } from '../../../helpers';

const ProductPriceWrapper = styled.div`
  display: flex;
  align-items: baseline;
  flex-direction: column;
`;

const NormalPrice = styled.p`
  font-size: ${toRem(24)};
  font-weight: ${theme.fontWeights.bold};
  margin-right: ${toRem(12)};
`;

const DiscountPrice = styled(NormalPrice)`
  color: ${theme.colorScheme.red};
`;
const VAT = styled.p`
  margin: 0 ${toRem(12)};
  display: none;
`;

const OriginalPrice = styled.p`
  color: ${theme.colorScheme.mediumgrey};
  text-decoration: line-through;
`;

const CartForm = styled(Form)`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-bottom: 1rem;
  margin-top: 0.75rem;
  ${theme.above.md} {
    margin-bottom: 1rem};
  }
  ${theme.below.md} {
    align-items: center;
  }
  
  .add-to-cart {
    position: relative;
    overflow: hidden;
    background: linear-gradient(${theme.colorScheme.addtocartswipeangle}, ${theme.colorScheme.addtocartlight}, ${theme.colorScheme.addtocartdark});
    color: ${theme.colorScheme.addtocarttext};
    border: none;
    border-radius: 8px;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    svg path {
      fill: ${theme.colorScheme.addtocarttext};
    }
  }
  
  .add-to-cart:disabled {
    padding: 4px 24px;
    font-size: 14px;
    background: ${theme.colorScheme.black};
    color: ${theme.colorScheme.white};
    svg path {
        fill: ${theme.colorScheme.white};
    }
  }

  .add-to-cart:not(:disabled):hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    border: none;
    color: ${theme.colorScheme.addtocarttext};
    svg path {
        fill: ${theme.colorScheme.addtocarttext};
    }
  }

  /* Idle streak: Moves continuously left to right */
  .add-to-cart:not(:disabled)::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 50%;
    height: 100%;
    background: linear-gradient(
      to right,
      rgba(${theme.colorScheme.addtocartswipe}, 0) 10%,
      rgba(${theme.colorScheme.addtocartswipe}, 0.5) 50%,
      rgba(${theme.colorScheme.addtocartswipe}, 0) 90%
    );
    filter: blur(8px);
    transform: skewX(-20deg);
    animation: streak 13s linear infinite;
  }

  /* Hover streak: Bursts from center and expands outwards */
  .add-to-cart::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0%;
    height: 30%;
    background: radial-gradient(
      ellipse at center,
      rgba(255, 255, 255, 0.6) 0%,
      rgba(255, 255, 255, 0) 50%
    );
    transform: translate(-50%, -50%);
    opacity: 0;
  }
  .add-to-cart:hover::after {
    animation: ripple 1s forwards;
  }

  /* Keyframes for the hover ripple effect */
  @keyframes ripple {
      0% {
          width: 0%;
          height: 30%;
          opacity: 1;
      }
      100% {
          width: 300%;
          height: 300%;
          opacity: 0;
      }
  }

  /* Keyframes for the idle streak */
  @keyframes streak {
    0% {
      left: -100%;
    }
    23.08% { /* Streak moves for 3s out of 13s total */
      left: 150%;
    }
    100% {
      left: 150%;
    }
  }


`;

const style = {
  ProductPriceWrapper,
  NormalPrice,
  DiscountPrice,
  VAT,
  OriginalPrice,
  CartForm
};

export default style;
